import React, { useEffect, useState } from "react";
import { SetMakersArea } from "../components/master";
import { useDispatch, useSelector } from "react-redux";
import { PrimaryButton } from "../components/UIkit";
import { saveMakers } from "../reducks/makers/operations";
import { getMakers } from "../reducks/makers/selectors";

const MakersEdit = () => {
  const dispatch = useDispatch();
  const makersOnFirestore = useSelector(getMakers);
  const [makers, setMakers] = useState(makersOnFirestore);

  return (
    <section>
      <h2 className="u-text__headline u-text-center">メーカーの登録・編集</h2>
      <div className="c-section-container">
        <SetMakersArea makers={makers} setMakers={setMakers} />
      </div>
      <div className="module-spacer--small" />
      <div className="center">
        <PrimaryButton
          label={"上書き保存"}
          onClick={() => dispatch(saveMakers(makers))}
        />
      </div>
    </section>
  );
};

export default MakersEdit;
